import "url-search-params-polyfill"
import request from "../utils/fetch"
import auth from "../auth"
import { isomorphicVars } from "../scripts/isomorphicVars"

let tokenRefreshInProgress = null

export function urlParamify(params = {}) {
  const urlValues = Object.keys(params).reduce((urlParams, k) => {
    urlParams.append(k, params[k])
    return urlParams
  }, new URLSearchParams())

  return urlValues.toString()
}

export function addAuthHeaders() {
  const token = auth.getAccessToken()
  return token
    ? {
        authorization: `Bearer ${token}`
      }
    : {}
}

/**
 * Makes a request to the API endpoint, returning a promise
 *
 * @param  {string} url       The action we want to request
 * @param  {string} method    The http method
 * @param  {object} [params]  The params we want to pass to "fetch"
 *
 * @return {object}           The response data
 */
export default function api(method, action, params = {}) {
  const {
    api_endpoint: apiEndpoint,
    authentic_account_id: AuthenticAccountId
  } = isomorphicVars()

  let url = action.match(/^https?:/)
    ? action
    : `${apiEndpoint}/${action.replace(/^\//, "")}`
  let options = {
    method: method.toUpperCase(),
    headers: {
      accept: "application/json",
      "content-type": "application/json",
      "authentic-account-id": AuthenticAccountId,
      ...addAuthHeaders()
    }
  }

  if (Object.keys(params).length > 0) {
    // Add params to request
    if (options.method === "GET") {
      // Create a query string for GET requests
      url = `${url}?${urlParamify(params)}`
    } else {
      options = {
        ...options,
        body: JSON.stringify(params)
      }
    }
  }

  return request(url, options).catch(err => {
    if (err && err.response && err.response.status === 401) {
      if (!tokenRefreshInProgress) {
        tokenRefreshInProgress = auth
          .refreshToken()
          .then(newToken => {
            tokenRefreshInProgress = null
            return newToken
          })
          .catch(e => {
            tokenRefreshInProgress = null
            // that didn't work, clear the token
            auth.logout()
            if (e.response && e.response.status === 401) {
              console.log('refresh token has expired')
            } else {
              throw e
            }
          })
      }
      return tokenRefreshInProgress.then(() => {
        // re-run query with new token
        options.headers = {
          ...options.headers,
          ...addAuthHeaders()
        }
        return request(url, options)
      })
    }
    throw err
  })
}

export function apiAuth(method, action, params = {}) {
  const { auth_endpoint: AUTH_ENDPOINT } = isomorphicVars()
  action = `${AUTH_ENDPOINT}/api/${action.replace(/^\//, "")}`
  return api(method, action, params)
}



// WEBPACK FOOTER //
// ./webapp/api/index.js